export function scaricaBase64(base64: string, filename: string): void {
  const bytes = new Uint8Array(atob(base64).split('').map((c) => c.charCodeAt(0)))
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/octet-stream' }))
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
